import { render, staticRenderFns } from "./BarriersList.vue?vue&type=template&id=381252c0&scoped=true"
import script from "./BarriersList.vue?vue&type=script&lang=ts"
export * from "./BarriersList.vue?vue&type=script&lang=ts"
import style0 from "./BarriersList.vue?vue&type=style&index=0&id=381252c0&prod&lang=scss&scoped=true"
import style1 from "./BarriersList.vue?vue&type=style&index=1&id=381252c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381252c0",
  null
  
)

export default component.exports